import backend from '../index'

export default async function getGroups() {
  const groups = await backend.get(`/groups`)
  return groups.data
}
